module.exports = __webpack_public_path__ + "static/img/icon_rt-por.a03cd040.svg";